import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "i18n";
import { onSuccess, onError } from "Utils";
import { ArrowLeft, SettingIcon } from "../Common/Icons";
import ModalCloseButton from "../Common/Modal/ModalCloseButton";
import { TTPModal, DragModal } from "../Common/Modal/TTPModal";
import classnames from "classnames";
import styles from "./BudgetModal.local.scss";
import { Button, Tooltip } from "antd";
import AsyncSelect from "react-select/lib/Async";
import { push } from "react-router-redux";
import { BUDGET_STATUS } from "Config";

import {
  initQuickBudgetClient,
  initBudgetSettingClient,
  setBudgetSettingClient,
  setBudgetYear
} from "Actions";
import {
  fetchCollaboratorSuggestions,
  saveQuickBudget,
  fetchSquadsSuggestions,
  fetchBusinessUnitSuggestions,
  fetchClusterSuggestions
} from "thunks";
import debounce from "lodash.debounce";

class BudgetModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      budget: props.budget,
      totalSubHourlyBudget: 0,
      disabledSave: true,
      saved: false
    };

    this.loadCollaboratorSuggestionsBE = debounce(
      this.loadCollaboratorSuggestionsBE,
      1000
    );
    this.loadCollaboratorSuggestionsMA = debounce(
      this.loadCollaboratorSuggestionsMA,
      1000
    );
    this.loadCollaboratorSupervisorSuggestions = debounce(
      this.loadCollaboratorSupervisorSuggestions,
      1000
    );
    this.loadSquadSuggestions = debounce(this.loadSquadSuggestions, 1000);
    this.loadClusterSuggestions = debounce(this.loadClusterSuggestions, 1000);
    this.loadBusinessUnitSuggestions = debounce(
      this.loadBusinessUnitSuggestions,
      1000
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      ((this.props.budget.hourlyBudget ||
        this.props.budget.economicBudget ||
        this.props.budget.managerId ||
        this.props.budget.id) &&
        (!prevState.budget.hourlyBudget &&
          !prevState.budget.economicBudget &&
          !prevState.budget.managerId &&
          !prevState.budget.id)) ||
      this.props.budget.id !== prevProps.budget.id ||
      this.props.client.id !== prevProps.client.id ||
      this.props.year !== prevProps.year
    ) {
      this.setState({
        budget: { ...this.props.budget },
        saved: this.props.budget.id !== null,
        disabledSave:
          this.props.budget.subs.filter(b => b.zone === "Belgique")[0]
            .managerId == null
      });
    }
  }

  //@todo update
  loadCollaboratorSuggestionsBE = (searchWord, callback) => {
    this.props
      .dispatch(fetchCollaboratorSuggestions(searchWord))
      .then(res => {
        let collaborators = [];
        res.value.data.data.forEach(t => {
          if (!t.zone || t.zone === 1) {
            collaborators.push({
              value: t.id,
              label: t.name,
              color: "#000000"
            });
          }
        });
        callback(collaborators);
      })
      .catch(er => {
        callback([]);
      });
  };

  //@todo update
  loadCollaboratorSuggestionsMA = (searchWord, callback) => {
    this.props
      .dispatch(fetchCollaboratorSuggestions(searchWord))
      .then(res => {
        let collaborators = [];
        res.value.data.data.forEach(t => {
          if (!t.zone || t.zone === 2) {
            collaborators.push({
              value: t.id,
              label: t.name,
              color: "#000000"
            });
          }
        });
        callback(collaborators);
      })
      .catch(er => {
        callback([]);
      });
  };

  loadCollaboratorSupervisorSuggestions = (searchWord, callback) => {
    this.props
      .dispatch(fetchCollaboratorSuggestions(searchWord))
      .then(res => {
        const collaborators = res.value.data.data.map(t => {
          return {
            value: t.id,
            label: t.name,
            color: "#000000"
          };
        });
        callback(collaborators);
      })
      .catch(er => {
        callback([]);
      });
  };

  loadSquadSuggestions = (searchWord, callback) => {
    this.props
      .dispatch(fetchSquadsSuggestions(searchWord))
      .then(res => {
        const squads = res.value.data.data.map(t => {
          return {
            value: t.id,
            label: t.label,
            color: "#000000"
          };
        });
        callback(squads);
      })
      .catch(er => {
        callback([]);
      });
  };

  loadClusterSuggestions = (searchWord, callback) => {
    this.props
      .dispatch(fetchClusterSuggestions(searchWord))
      .then(res => {
        const clusters = res.value.data.data.map(t => {
          return {
            value: t.id,
            label: t.label,
            color: "#000000"
          };
        });
        callback(clusters);
      })
      .catch(er => {
        callback([]);
      });
  };

  loadBusinessUnitSuggestions = (searchWord, callback) => {
    this.props
      .dispatch(fetchBusinessUnitSuggestions(searchWord))
      .then(res => {
        const businessUnits = res.value.data.data.map(t => {
          return {
            value: t.id,
            label: t.label,
            color: "#000000"
          };
        });
        callback(businessUnits);
      })
      .catch(er => {
        callback([]);
      });
  };

  handleQuickBudgetStatus = () => {
    const { budget } = this.state;
    let delegated = false;
    let nbrDelegated = 0;
    budget &&
      budget.subs &&
      budget.subs.forEach(principal => {
        if (principal.managerId === null && principal.value > 0) {
          delegated = true;
        } else if (principal.managerId !== null && principal.value !== null) {
          nbrDelegated++;
        }
      });
    return budget && budget.hourlyBudget && budget.hourlyBudget > 0 && delegated
      ? BUDGET_STATUS.STATUS_DELEGATION_NOT_AFFECTED
      : budget.hourlyBudget > 0 && !delegated && nbrDelegated > 0
        ? BUDGET_STATUS.STATUS_BUDGET_BY_ZONE_AFFECTED
        : budget.hourlyBudget > 0 && !delegated && nbrDelegated === 0
          ? BUDGET_STATUS.STATUS_GLOBAL_BUDGET_AFFECTED
          : BUDGET_STATUS.STATUS_GLOBAL_BUDGET_NOT_AFFECTED;
  };

  handleSaveQuickBudget = event => {
    const { budget } = this.state;
    const { client, year } = this.props;
    let status = this.handleQuickBudgetStatus();
    this.props.dispatch(saveQuickBudget(budget, client.id, year, status)).then(
      res => {
        onSuccess(res, {
          title: _("saveSuccess"),
          body: _("successfulAction")
        });
        this.setState({ saved: true });
      },
      err => {
        onError(_("errorOccured"));
      }
    );
  };

  handleSaveQuickBudgetAndNext = event => {
    const { budget } = this.state;
    const { client, year } = this.props;
    let status = this.handleQuickBudgetStatus();
    this.props.dispatch(saveQuickBudget(budget, client.id, year, status)).then(
      res => {
        onSuccess(res, {
          title: _("saveSuccess"),
          body: _("successfulAction")
        });
        this.setState({ saved: true });

        this.props.handleQuickBudgetNext(this.props.client.id);
      },
      err => {
        onError(_("errorOccured"));
      }
    );
  };

  handleChangeHourlyBudget = event => {
    const total = this.state.budget.subs.reduce(
      (accumulator, current) =>
        parseFloat(accumulator ? accumulator : 0.0) +
        parseFloat(current.value ? current.value : 0.0),
      0
    );
    // if (total <= event.target.value) {
    //   this.setState({
    //     budget: {
    //       ...this.state.budget,
    //       hourlyBudget: event.target.value
    //     }
    //   });
    // }
    this.setState({
      disabledSave: total > event.target.value,
      budget: {
        ...this.state.budget,
        hourlyBudget: parseFloat(event.target.value ? event.target.value : 0.0)
      }
    });
  };

  handleChangeSubHourlyBudget = (event, zone) => {
    let subs = [...this.state.budget.subs].map(sub => {
      return sub.zone === zone
        ? {
            ...sub,
            value: parseFloat(event.target.value ? event.target.value : 0.0)
          }
        : sub;
    });
    const total = subs.reduce(
      (accumulator, current) =>
        parseFloat(accumulator ? accumulator : 0.0) +
        parseFloat(current.value ? current.value : 0.0),
      0.0
    );
    if (
      total >
      this.state.budget.hourlyBudget - this.state.budget.supervisor.value
    ) {
      this.setState({
        budget: {
          ...this.state.budget
        }
      });
    } else {
      this.setState({
        totalSubHourlyBudget: total,
        budget: {
          ...this.state.budget,
          subs: subs
        }
      });
    }
  };

  handleChangeSupervisorHourlyBudget = event => {
    let total = parseFloat(event.target.value);
    this.state.budget.subs.forEach(i => (total += parseFloat(i.value)));
    if (total <= this.state.budget.hourlyBudget) {
      this.setState({
        budget: {
          ...this.state.budget,
          supervisor: {
            ...this.state.budget.supervisor,
            value: parseFloat(event.target.value ? event.target.value : 0.0)
          }
        }
      });
    }
  };

  handleSubBudgetManagerChange = (selected, zone) => {
    let subs = [...this.state.budget.subs].map(sub => {
      return sub.zone === zone
        ? {
            ...sub,
            managerId: selected.value,
            managerName: selected.label
          }
        : sub;
    });
    this.setState({
      disabledSave: zone === "Belgique" && selected.value == null,
      budget: {
        ...this.state.budget,
        subs: subs
      }
    });
  };

  handleSubBudgetSupervisorChange = selected => {
    this.setState({
      budget: {
        ...this.state.budget,
        supervisor: {
          ...this.state.budget.supervisor,
          supervisorId: selected.value,
          supervisorName: selected.label
        }
      }
    });
  };

  handleApplyHourlySuggestion = disc => {
    const { suggestions } = this.props;
    if (suggestions[disc]) {
      this.setState({
        budget: {
          ...this.state.budget,
          ...suggestions[disc],
          economicBudget: this.state.budget.economicBudget,
          squad: this.state.budget.squad,
          cluster: this.state.budget.cluster,
          businessUnit: this.state.budget.businessUnit
        },
        disabledSave:
          suggestions[disc].subs.filter(b => b.zone === "Belgique")[0]
            .managerId == null
      });
    }
  };

  handleApplyEconomicSuggestion = disc => {
    const { suggestions } = this.props;
    if (disc === "economicBudget" || disc === "economicBudgetPlus") {
      this.setState({
        budget: {
          ...this.state.budget,
          economicBudget: suggestions.time[disc]
        }
      });
    }
  };

  handleChangeEconomicBudget = event => {
    this.setState({
      budget: {
        ...this.state.budget,
        economicBudget: event.target.value
      }
    });
  };

  handleChangeSquad = selected => {
    this.setState({
      budget: {
        ...this.state.budget,
        squad: {
          squadId: selected.value,
          squadName: selected.label
        }
      }
    });
  };

  handleChangeCluster = selected => {
    this.setState({
      budget: {
        ...this.state.budget,
        cluster: {
          clusterId: selected.value,
          clusterName: selected.label
        }
      }
    });
  };

  handleChangeBU = selected => {
    this.setState({
      budget: {
        ...this.state.budget,
        businessUnit: {
          businessUnitId: selected.value,
          businessUnitName: selected.label
        }
      }
    });
  };

  handleRedirectBudgetSetting = ({ id, name }) => {
    const { dispatch, year } = this.props;
    dispatch(initQuickBudgetClient());
    dispatch(setBudgetYear(this.props.year));
    dispatch(initBudgetSettingClient());
    dispatch(setBudgetSettingClient({ id, name }));
    dispatch(push(`/budget-setting?name=${name}&id=${id}&year=${year}`));
  };

  handleCancelQuickBudget = () => {
    this.setState({
      budget: {
        hourlyBudget: null,
        economicBudget: null,
        managerId: null,
        managerName: null
      }
    });
    this.props.dispatch(initQuickBudgetClient());
  };

  renderSubHourlyBudget(subBudget) {
    const { suggestions, parameterSettings } = this.props;
    return (
      <div className="medium-6 small-6">
        <div className={styles.input_div} style={{ marginBottom: 0 }}>
          <span>{_(`Budget horaire (${subBudget.zone})`)}</span>
          <input
            type={"number"}
            placeholder={_("enterHourlyBudget")}
            value={subBudget.value ? subBudget.value : ""}
            onChange={e => this.handleChangeSubHourlyBudget(e, subBudget.zone)}
          />
        </div>
        <Tooltip
          key={`lastYearBudget`}
          placement="top"
          title={_("Budget de l'année précédente")}
        >
          <span
            className={`${styles.indice_frame} ${styles.indice_frame_light_1}`}
          >
            {suggestions.budget &&
              suggestions.budget.subs &&
              suggestions.budget.subs.filter(s => subBudget.zone === s.zone)[0]
                .value}{" "}
            {_("H")}
          </span>
        </Tooltip>
        <Tooltip
          key={`lastYearTime`}
          placement="top"
          title={_("Réalisé de l'année précédente")}
        >
          <span
            className={`${styles.indice_frame} ${styles.indice_frame_light_2}`}
          >
            {suggestions.time &&
              suggestions.time.subs &&
              suggestions.time.subs.filter(s => subBudget.zone === s.zone)[0]
                .value}{" "}
            {_("H")}
          </span>
        </Tooltip>
        <br />
        <div className={styles.select_dev}>
          <span>
            {subBudget.zone === "Belgique"
              ? "GD Gest dossier *"
              : "GE Gest encodage"}
          </span>
          <AsyncSelect
            value={{
              value: subBudget.managerId,
              label: subBudget.managerName,
              color: "#000"
            }}
            isDisabled={parameterSettings.synchroRole}
            key={subBudget.zone + "collaborator"}
            isMulti={false}
            placeholder={_("selectionner le responsable")}
            onChange={e => this.handleSubBudgetManagerChange(e, subBudget.zone)}
            classNamePrefix="ttp-select"
            defaultOptions
            loadOptions={
              //@todo update
              subBudget.zone === "Belgique"
                ? this.loadCollaboratorSuggestionsBE
                : this.loadCollaboratorSuggestionsMA
            }
            className={`ttp-select empty-box`}
          />
        </div>
      </div>
    );
  }

  render() {
    const { budget, saved } = this.state;
    const { suggestions } = this.props;
    return (
      <TTPModal
        mask={true}
        visible={this.props.isModalVisible}
        footer={null}
        width={850}
      >
        {this.props.isModalVisible ? (
          <div className="tamtam-modal upload-modal upload-modal__body">
            <ModalCloseButton onClose={this.handleCancelQuickBudget} />
            <div className="upload-modal__content">
              <DragModal>
                <div className="upload-modal__header small-12">
                  <div className="upload-modal__header-icon">
                    <SettingIcon fill="#2495E1" size="20" />
                  </div>
                  <div
                    className="upload-modal__header-title"
                    style={{ display: "inline-block", marginRight: "auto" }}
                  >
                    {_("Configuration rapide de budget")} {this.props.year}
                  </div>

                  <button
                    onClick={() =>
                      this.props.handleQuickBudgetPrevious(this.props.client.id)
                    }
                    className={styles.modal_header__next}
                  >
                    <ArrowLeft />
                  </button>
                  <button
                    onClick={() =>
                      this.props.handleQuickBudgetNext(this.props.client.id)
                    }
                    className={styles.modal_header__previous}
                  >
                    <ArrowLeft />
                  </button>
                </div>
              </DragModal>
              <div className={styles.modal_content}>
                <h3>
                  {_("Pour le client ")}{" "}
                  <span
                    style={{
                      fontWeight: "700",
                      color: "rgba(0, 0, 0, 0.65)",
                      fontSize: ".9rem"
                    }}
                  >{`${this.props.client.name}`}</span>
                </h3>
                <div className={classnames("row")}>
                  <div className="medium-12 small-12">
                    <div className={classnames("", styles.form_group)}>
                      <div className={styles.select_dev}>
                        <span>{_("squad")} </span>
                        <AsyncSelect
                          value={{
                            value: budget.squad.squadId,
                            label: budget.squad.squadName,
                            color: "#000"
                          }}
                          key={budget.squad.squadId + "squad"}
                          isMulti={false}
                          placeholder={_("Selectionner le Squad")}
                          onChange={e => this.handleChangeSquad(e)}
                          classNamePrefix="ttp-select"
                          defaultOptions
                          loadOptions={this.loadSquadSuggestions}
                          className={`ttp-select empty-box`}
                        />
                      </div>
                      <div className={styles.select_dev}>
                        <span>{_("Cluster")} </span>
                        <AsyncSelect
                          value={{
                            value: budget.cluster.clusterId,
                            label: budget.cluster.clusterName,
                            color: "#000"
                          }}
                          key={budget.cluster.clusterId + "cluster"}
                          isMulti={false}
                          placeholder={_("Selectionner le Cluster")}
                          onChange={e => this.handleChangeCluster(e)}
                          classNamePrefix="ttp-select"
                          defaultOptions
                          loadOptions={this.loadClusterSuggestions}
                          className={`ttp-select empty-box`}
                        />
                      </div>
                      <div className={styles.select_dev}>
                        <span>{_("BU")} </span>
                        <AsyncSelect
                          value={{
                            value: budget.businessUnit.businessUnitId,
                            label: budget.businessUnit.businessUnitName,
                            color: "#000"
                          }}
                          key={budget.businessUnit.businessUnitId + "BU"}
                          isMulti={false}
                          placeholder={_("Selectionner la BU")}
                          onChange={e => this.handleChangeBU(e)}
                          classNamePrefix="ttp-select"
                          defaultOptions
                          loadOptions={this.loadBusinessUnitSuggestions}
                          className={`ttp-select empty-box`}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="medium-12 small-12">
                    <div className={classnames("", styles.form_group)}>
                      <div className={styles.input_div}>
                        <span>{_("Budget économique (€)")}</span>
                        <input
                          type={"number"}
                          placeholder={_("enterEconomicBudget")}
                          value={
                            budget.economicBudget ? budget.economicBudget : ""
                          }
                          onChange={this.handleChangeEconomicBudget}
                        />
                      </div>
                      <Tooltip
                        key={`lastYearBudget`}
                        placement="top"
                        title={_("Réalisée de l'année précédente")}
                      >
                        <span
                          className={`${styles.indice_frame} ${
                            styles.indice_frame_2
                          }`}
                          onClick={() =>
                            this.handleApplyEconomicSuggestion("economicBudget")
                          }
                        >
                          {suggestions.time && suggestions.time.economicBudget}{" "}
                          {_("€")}
                        </span>
                      </Tooltip>
                      <Tooltip
                        key={`lastYearTime`}
                        placement="top"
                        title={_("Réalisé de l'année précédente +2%")}
                      >
                        <span
                          className={`${styles.indice_frame} ${
                            styles.indice_frame_2
                          }`}
                          onClick={() =>
                            this.handleApplyEconomicSuggestion(
                              "economicBudgetPlus"
                            )
                          }
                        >
                          {suggestions.time &&
                            suggestions.time.economicBudgetPlus}
                          {_(" €")}
                          {" (+2%)"}
                        </span>
                      </Tooltip>
                    </div>
                  </div>
                </div>

                <div className={classnames("row", styles.form_group)}>
                  <div className="medium-12 small-12">
                    <div className={styles.input_div}>
                      <span>{_("Budget horaire")}</span>
                      <input
                        type={"number"}
                        placeholder={_("enterHourlyBudget")}
                        value={budget.hourlyBudget ? budget.hourlyBudget : ""}
                        onChange={this.handleChangeHourlyBudget}
                      />
                    </div>
                    <Tooltip
                      key={`lastYearBudget`}
                      placement="top"
                      title={_("Budget de l'année précédente")}
                    >
                      <span
                        className={`${styles.indice_frame} ${
                          styles.indice_frame_1
                        }`}
                        onClick={() =>
                          this.handleApplyHourlySuggestion("budget")
                        }
                      >
                        {suggestions.budget && suggestions.budget.hourlyBudget}{" "}
                        {_("H")}
                      </span>
                    </Tooltip>
                    <Tooltip
                      key={`lastYearTime`}
                      placement="top"
                      title={_("Réalisé de l'année précédente")}
                    >
                      <span
                        className={`${styles.indice_frame} ${
                          styles.indice_frame_2
                        }`}
                        onClick={() => this.handleApplyHourlySuggestion("time")}
                      >
                        {suggestions.time && suggestions.time.hourlyBudget}{" "}
                        {_("H")}
                      </span>
                    </Tooltip>
                  </div>
                  {suggestions.budget &&
                    budget.supervisor && (
                      <div className="medium-12 small-12">
                        <div className={styles.select_dev}>
                          <span>{_("Supervisor")}</span>
                          <AsyncSelect
                            value={{
                              value: budget.supervisor.supervisorId,
                              label: budget.supervisor.supervisorName,
                              color: "#000"
                            }}
                            // key={subBudget.zone + "collaborator"}
                            isMulti={false}
                            placeholder={_("selectionner le responsable")}
                            onChange={e =>
                              this.handleSubBudgetSupervisorChange(e)
                            }
                            classNamePrefix="ttp-select"
                            defaultOptions
                            loadOptions={
                              this.loadCollaboratorSupervisorSuggestions
                            }
                            className={`ttp-select empty-box`}
                          />
                        </div>

                        <div
                          className={styles.input_div}
                          style={{ marginBottom: 0 }}
                        >
                          <span>{_(`Budget horaire (superviseur)`)}</span>
                          <input
                            type={"number"}
                            placeholder={_("enterHourlyBudget")}
                            value={
                              budget.supervisor ? budget.supervisor.value : ""
                            }
                            onChange={e =>
                              this.handleChangeSupervisorHourlyBudget(e)
                            }
                          />
                        </div>
                      </div>
                    )}
                  {budget.subs &&
                    budget.subs.map(b => this.renderSubHourlyBudget(b))}
                </div>
              </div>
              <div className={styles.modal_footer}>
                <Button
                  type={"success"}
                  style={{
                    fontFamily: "Roboto",
                    fontStyle: "normal",
                    fontWeight: 500,
                    fontSize: 14,
                    height: 37,
                    margin: "18px 3px 0px",
                    // background: `${
                    //   !this.state.disabledSave ? "#18A0FB" : "#f5f5f5"
                    // }`,
                    background: `${"#18A0FB"}`,
                    float: "right",
                    textTransform: "uppercase",
                    // color: `${
                    //   !this.state.disabledSave ? "white" : "rgba(0, 0, 0, 0.25)"
                    // }`
                    color: `${"white"}`
                  }}
                  // disabled={this.state.disabledSave}
                  disabled={false}
                  loading={this.props.budget.loading}
                  onClick={this.handleSaveQuickBudgetAndNext}
                >
                  {_("saveAndNext")}
                </Button>
                <Button
                  type={"success"}
                  style={{
                    fontFamily: "Roboto",
                    fontStyle: "normal",
                    fontWeight: 500,
                    fontSize: 14,
                    height: 37,
                    margin: "18px 3px 0px",
                    // background: `${
                    //   !this.state.disabledSave ? "#18A0FB" : "#f5f5f5"
                    // }`,
                    background: `${"#18A0FB"}`,
                    float: "right",
                    textTransform: "uppercase",
                    // color: `${
                    //   !this.state.disabledSave ? "white" : "rgba(0, 0, 0, 0.25)"
                    // }`
                    color: `${"white"}`
                  }}
                  // disabled={this.state.disabledSave}
                  disabled={false}
                  loading={this.props.budget.loading}
                  onClick={this.handleSaveQuickBudget}
                >
                  {_("save")}
                </Button>
                <Button
                  type={"success"}
                  style={{
                    fontFamily: "Roboto",
                    fontStyle: "normal",
                    fontWeight: 500,
                    fontSize: 14,
                    height: 37,
                    margin: "18px 3px 0px",
                    float: "right",
                    textTransform: "uppercase"
                  }}
                  disabled={!saved}
                  loading={false}
                  onClick={() =>
                    this.handleRedirectBudgetSetting(this.props.client)
                  }
                >
                  {_("advancedConfig")}
                </Button>
                <Button
                  type={"success"}
                  style={{
                    fontFamily: "Roboto",
                    fontStyle: "normal",
                    fontWeight: 500,
                    fontSize: 14,
                    height: 37,
                    margin: "18px 3px 0px",
                    background: "transparent",
                    float: "left",
                    textTransform: "uppercase",
                    color: "#6D7F92"
                  }}
                  onClick={this.handleCancelQuickBudget}
                >
                  {_("cancel")}
                </Button>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </TTPModal>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  budget: state.budget.quick.budget,
  client: state.budget.quick.client,
  suggestions: state.budget.quick.suggestions,
  year: state.budget.quick.year,
  parameterSettings: state.parameterSettings.data,
  isModalVisible: state.budget.quick.isModalVisible
});

export default connect(mapStateToProps)(BudgetModal);



// WEBPACK FOOTER //
// ./src/components/Budget/BudgetModal.js